import * as React from 'react';

import { DataQualityDetailGroupDiv, DataQualityDetailGroupHeadingDiv } from '../style/DataQualityStyles';
import { DataQualityDetail, DataQualityDetailProps } from './DataQualityDetail';

export interface DataQualityDetailGroupProps {
  readonly details: ReadonlyArray<DataQualityDetailProps>;
  readonly message: string;
  readonly keyPrefix: string;
  readonly linksDisabled: boolean;
}

export function DataQualityDetailGroup(props: DataQualityDetailGroupProps): JSX.Element | null {
  if (props.details.length > 0) {
    return (
      <React.Fragment>
        <DataQualityDetailGroupHeadingDiv>
          {props.message}
        </DataQualityDetailGroupHeadingDiv>
        <DataQualityDetailGroupDiv>
          {
            props.details.map((detail, index, _) => (
              <DataQualityDetail
                key={props.keyPrefix + index.toString()}
                {...detail}
                linksDisabled={props.linksDisabled}
              />
            ))
          }
        </DataQualityDetailGroupDiv>
      </React.Fragment>
    );
  }

  return null;
}
